import { SLOTS } from './slots.js'

const FEED_TYPE_BADGES = {
  standard: { label: 'Standard', badgeClass: 'badge-outline' },
  favorites: { label: 'Favorites', badgeClass: 'badge-secondary' },
  trending: { label: 'Trending', badgeClass: 'badge-warning' },
  places_you_have_been: { label: "Places You've Been", badgeClass: 'badge-info' },
  places_with_multipliers: { label: 'Place Retargeting Multiplier', badgeClass: 'badge-accent' },
  deals_with_multipliers: { label: 'Deal Retargeting Multiplier', badgeClass: 'badge-accent' },
  promotional_multiplier: { label: 'Promotional Multiplier', badgeClass: 'badge-primary' },
  place_feed: { label: 'Place Feed', badgeClass: 'badge-info' }
}

const AUDIENCE_BADGES = {
  everyone: { label: 'Everyone', badgeClass: 'badge-outline' },
  anonymous: { label: 'Anonymous', badgeClass: 'badge-outline' },
  trialing: { label: 'Trialing', badgeClass: 'badge-outline' },
  active: { label: 'Member', badgeClass: 'badge-outline' },
  canceled: { label: 'Canceled', badgeClass: 'badge-outline' },
  uploaded_set: { label: 'From CSV', badgeClass: 'badge-outline' },
  over_21: { label: 'Over 21', badgeClass: 'badge-outline' },
  new_customer: { label: 'First Visit', badgeClass: 'badge-outline' }
}

// Feeds scoped to a college town (area). Manually ordered (drag reorder); `rank` is the
// row's place in that order (old CMS list). Active is an in-table toggle (the canonical way
// an on/off state renders); pages pass onToggle.
export default {
  key: 'feed',
  deleteLabel: 'Archive',
  label: 'Feed',
  icon: 'feeds',
  columns: [
    { slot: SLOTS.METADATA, field: 'rank', label: 'Rank', renderer: 'points', align: 'right' },
    { slot: SLOTS.CONTEXT, field: 'area.name', label: 'College Town', areaScoped: true, link: 'area.url' },
    { slot: SLOTS.PRIMARY, field: 'name', link: 'url' },
    { slot: SLOTS.STATUS, field: 'active', label: 'Active', renderer: 'toggle' },
    { slot: SLOTS.METADATA, field: 'feed_type', label: 'Type', renderer: 'state_badge', badges: FEED_TYPE_BADGES, labelField: 'feed_type_label' },
    { slot: SLOTS.METADATA, field: 'audience_names', label: 'Audiences', renderer: 'tags', badges: AUDIENCE_BADGES },
    { slot: SLOTS.METADATA, field: 'schedule', label: 'Schedule', renderer: 'schedule' },
    { slot: SLOTS.METADATA, field: 'manual_ranking_enabled', label: 'Manual Ranking', renderer: 'boolean', trueLabel: 'Manually ranked', falseLabel: 'Not manually ranked' }
  ],
  empty: { icon: 'feeds', message: 'No feeds found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY] }
}
